module.exports = __webpack_public_path__ + "img/monitoring-truck-yellow.efa36265.svg";